import { IHttpApi } from '@cian/http-api/shared';

import { ILogger } from '@cian/logger';
import { ResponseError } from '../errors/ResponseError';
import {
  TGetVillageListSummaryRequest,
  TGetVillageListSummaryResponse,
  fetchGetVillageListSummary,
} from '../../node/repositories/countryside-search/v1/get-village-list-summary';
import { prepareSearchResultMetrics } from '../utils/seo';
import { ISearchResultMetricsSchema } from '../repositories/countryside-search/entities/search_result_metrics/SearchResultMetricsSchema';

export async function getSearchResultMetrics(
  httpApi: IHttpApi,
  logger: ILogger,
  parameters: TGetVillageListSummaryRequest,
  totalItems?: number,
): Promise<ISearchResultMetricsSchema | null> {
  try {
    const { response, statusCode } = await fetchGetVillageListSummary<
      TGetVillageListSummaryResponse,
      TGetVillageListSummaryResponse
    >({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'getSearchResultMetrics',
        message: response.message,
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }

    return prepareSearchResultMetrics(response.offersAggs, totalItems);
  } catch (error) {
    logger.error(error, { message: 'Error in getSearchResultMetrics' });

    return null;
  }
}
